
import { defineComponent } from "vue";

export default defineComponent({
  name: "FeatureSection",
  props: {
    uncolored: String,
    colored: String,
    description: String,
    img: String,
    alt: String,
    color: String,
    id: String
  }
});
